'use client';

import { Box, Tooltip, TooltipProps, LinkProps } from '@mui/material';
import Link from 'next/link';

export const HyperLink = (props: {
  pathname: string;
  label: string;
  tooltipPlacement?: TooltipProps['placement'];
  linkStyle?: LinkProps['style'];
}) => {
  const { pathname, label, linkStyle } = props;

  return (
    <Box onClick={(e) => e.stopPropagation()}>
      <Tooltip
        placement={props.tooltipPlacement ?? 'bottom'}
        title="View Details"
      >
        <Link
          href={pathname}
          prefetch={false}
          onClick={(e) => e.stopPropagation()}
          style={{ textDecoration: 'none' }}
        >
          <Box
            component="span"
            sx={{
              borderRadius: 50,
              display: 'inline-block',
              fontWeight: 500,
              color: 'info.main',
              py: 0.5,
              px: 1.25,
              ...linkStyle,
            }}
          >
            {label}
          </Box>
        </Link>
      </Tooltip>
    </Box>
  );
};
